<template>
  <div>
      <v-flex style="background-color:#292929; color: #eee;" class="px-3 py-1 elevation-0 xs12"> 
        <h3 class="font-weight-bold subtitle xs12 flex">{{f_field.title}}</h3>
    </v-flex>
  </div>
</template>

<script>

export default {
  name: 'EditFieldHeader',
  data () {
    return {
    }
  },
  props: ['field','artist','placeholder', 'label', 'name', 'value'],
  methods: {
  },
  computed: {
    f_field (){ return this.field },
    f_artist () { return this.artist }
  }
}

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/artists/EditFieldHeader.vue